"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_AVAILABLE_COUNTRY_CODES = exports.MAX_PHONE_NUMBER_LENGTH = void 0;
// while not enforced, https://en.wikipedia.org/wiki/E.164 standard is widely adopted so we can safely assume max length 15
var MAX_PHONE_NUMBER_LENGTH = 15; // Type as CountryCodes when available from packages/design-language/src/i18n/countries.ts

exports.MAX_PHONE_NUMBER_LENGTH = MAX_PHONE_NUMBER_LENGTH;
var DEFAULT_AVAILABLE_COUNTRY_CODES = ['US', 'CA', 'AU', 'JP', 'DE'];
exports.DEFAULT_AVAILABLE_COUNTRY_CODES = DEFAULT_AVAILABLE_COUNTRY_CODES;